import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import { CartProvider } from "@/context/CartContext";
import { CartDrawer } from "@/components/CartDrawer";
import {
  HomePage,
  AboutPage,
  ProductsPage,
  ProductDetailPage,
  CompareProductsPage,
  WheyProteinPage,
  CreatinePage,
  PreWorkoutPage,
  FatBurnerPage,
  BlogPage,
  BlogPostPage,
  RecipesPage,
  RecipeDetailPage,
  AthletesPage,
  ReviewsPage,
  StoresPage,
  ContactPage,
} from "@/pages";

// Smooth scroll to top on route change with optimization
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame for smoother scroll
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        behavior: 'instant' // Instant on route change, smooth within page
      });
    });
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    // Disable right-click context menu for better UX (optional)
    // document.addEventListener('contextmenu', (e) => e.preventDefault());
    
    // Add performance optimization
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    return () => {
      // Cleanup
    };
  }, []);

  return (
    <>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="page-transition">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:slug" element={<ProductDetailPage />} />
              <Route path="/compare-products" element={<CompareProductsPage />} />
              <Route path="/whey-protein" element={<WheyProteinPage />} />
              <Route path="/creatine" element={<CreatinePage />} />
              <Route path="/pre-workout" element={<PreWorkoutPage />} />
              <Route path="/fat-burner" element={<FatBurnerPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/recipes" element={<RecipesPage />} />
              <Route path="/recipes/:slug" element={<RecipeDetailPage />} />
              <Route path="/athletes" element={<AthletesPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/stores" element={<StoresPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </div>
          <CartDrawer />
        </BrowserRouter>
      </CartProvider>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
